import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let IconBase = class IconBase extends Vue {
    color;
    width;
    height;
    alpha;
};
__decorate([
    Prop(String)
], IconBase.prototype, "color", void 0);
__decorate([
    Prop({ default: '70', type: String })
], IconBase.prototype, "width", void 0);
__decorate([
    Prop({ default: '42', type: String })
], IconBase.prototype, "height", void 0);
__decorate([
    Prop({ default: '1', type: String })
], IconBase.prototype, "alpha", void 0);
IconBase = __decorate([
    Component({
        name: 'iconBase',
    })
], IconBase);
export default IconBase;
